import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const fetchSiteStations = async (site_id: any) => {
  const result = await fetch(`${REACT_APP_VMS_BASE_URL}/sites/${site_id}`);
  const stations = await result.json();
  return stations;
};

export default fetchSiteStations;
